<template>
  <div class="py-2 d-flex justify-content-between gap-8" :class="className" v-bind="$attrs"
       style="padding: 0 24px;"
  >
    <!-- Mute/Unmute Button -->
    <button
      type="button"
      :class="[
        'bg-white h-14 w-14 rounded-full text-xl flex items-center justify-center shadow-xl',
        !isMicOn ? 'text-black' : 'text-danger'
      ]"
      @click="toggleMute"
      style="flex: 1; background: #4e4d5a !important; border: none; font-size: 24px; width: 100%; height: 100%; max-height: 80px; max-width: 80px; border-radius: 50% !important; position: relative;"
      :style="{
        color: !audioAvailable ? 'red !important' : 'transparent',
      }"
    >
      <i :style="{color: isMicOn ? '#ad1010' : 'inherit'}" :class="!isMicOn ? 'feather-mic-off' : 'feather-mic'"></i>

      <i v-show="!audioAvailable" style="font-size: 24px; color: #ad1010; position: absolute; right: 0; top: 0; background: #fff; border-radius: 50%; padding: 2px;" class="feather-alert-circle"></i>
    </button>

    <!-- End Call Button -->
    <button
      type="button"
      class="rounded-full text-3xl flex items-center justify-center shadow-xl"
      @click="endCall"
      style="flex: 1; background: transparent; color: #ad1010; border: none; font-size: 24px; width: 100%; height: 100%; max-height: 80px; max-width: 80px; border-radius: 50% !important;"
    >
      <i class="feather-phone-off"></i>
    </button>

    <!-- Video On/Off Button -->
    <button
      type="button"
      :class="[
        'bg-white h-14 w-14 rounded-full text-xl flex items-center justify-center shadow-xl',
        !isVideoOn ? 'text-black' : 'text-danger'
      ]"
      @click="toggleVideo"
      style="flex: 1; background: #4e4d5a !important; border: none; font-size: 24px; width: 100%; height: 100%; max-height: 80px; max-width: 80px; border-radius: 50% !important; position: relative;"
      :style="{
        color: !videoAvailable ? 'red !important' : 'transparent',
      }"
    >
      <i :style="{color: isVideoOn ? '#ad1010' : 'inherit'}" :class="!isVideoOn ? 'feather-video-off' : 'feather-video'"></i>
      <i v-show="!videoAvailable" style="font-size: 24px; color: #ad1010; position: absolute; right: 0; top: 0; background: #fff; border-radius: 50%; padding: 2px;" class="feather-alert-circle"></i>
    </button>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faMicrophone, faMicrophoneSlash, faVideo, faVideoSlash, faPhone } from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'VideoControl',
  components: {
    FontAwesomeIcon,
  },
  props: {
    isVideoOn: {
      type: Boolean,
      required: true,
    },
    isMicOn: {
      type: Boolean,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
    toggleMute: {
      type: Function,
      required: true,
    },
    endCall: {
      type: Function,
      required: true,
    },
    toggleVideo: {
      type: Function,
      required: true,
    },
    videoAvailable: {
      type: Function,
      required: true,
    },
    audioAvailable: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>
/* Add any component-specific styles here if needed */
</style>
